export default "__VITE_ASSET__u697IDYq__"